var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.33337H5C3.89 2.33337 3 3.23337 3 4.33337V18.3334C3 19.4334 3.89 20.3334 5 20.3334H9L12 23.3334L15 20.3334H19C20.1 20.3334 21 19.4334 21 18.3334V4.33337C21 3.23337 20.1 2.33337 19 2.33337ZM19 18.3334H14.17L13.58 18.9234L12 20.5034L10.41 18.9134L9.83 18.3334H5V4.33337H19V18.3334ZM11 15.3334H13V17.3334H11V15.3334ZM12 7.33337C13.1 7.33337 14 8.23337 14 9.33337C14 11.3334 11 11.0834 11 14.3334H13C13 12.0834 16 11.8334 16 9.33337C16 7.12337 14.21 5.33337 12 5.33337C9.79 5.33337 8 7.12337 8 9.33337H10C10 8.23337 10.9 7.33337 12 7.33337Z",
    fill: "#0BA9F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveHelpIcon);
export default __webpack_public_path__ + "static/media/live-help-icon.5c130abbd51096660fcf01da30a22747.svg";
export { ForwardRef as ReactComponent };